module.exports = __webpack_public_path__ + "static/img/5.747070c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-maquinaria-equipo-contratistas/5.png
// module id = 7OIo
// module chunks = 0